"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.mutateProducts = exports.deleteProduct = exports.updateProduct = exports.editAfterCreating = exports.createProductAndAdd = exports.createProduct = exports.getEditableTotalWhenFetching = exports.fetchEditableTotal = exports.fetchProduct = void 0;

var _reduxObservable = require("redux-observable");

var _map = require("rxjs/operators/map");

var _mapTo = require("rxjs/operators/mapTo");

var _filter = require("rxjs/operators/filter");

var _skipUntil = require("rxjs/operators/skipUntil");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("./actions");

var _actions2 = require("settings-ui-sdk/Properties/actions");

var ProductsAPI = _interopRequireWildcard(require("crm_data/products/ProductsAPI"));

var _selectors = require("settings-ui-sdk/Products/selectors");

var _selectors2 = require("settings-ui-sdk/Routes/selectors");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _API = require("settings-ui-sdk/Products/API");

var fetchProduct = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: ProductsAPI.search,
  initiatingActionType: _actions.ProductActionTypes.FETCH_PRODUCT,
  requestActions: _actions.FetchProduct,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.ProductActionTypes.FETCH_PRODUCT)
}));
exports.fetchProduct = fetchProduct;
var fetchEditableTotal = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: ProductsAPI.search,
  initiatingActionType: _actions.ProductActionTypes.FETCH_EDITABLE_TOTAL,
  requestActions: _actions.FetchEditableTotal,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.PENDING, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.ProductActionTypes.FETCH_EDITABLE_TOTAL)
}));
exports.fetchEditableTotal = fetchEditableTotal;

var getEditableTotalWhenFetching = function getEditableTotalWhenFetching($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_actions.FetchProductActionTypes.SUCCESS, _actions2.FetchProductPropertiesActionTypes.SUCCESS).pipe((0, _skipUntil.skipUntil)($action.ofType(_actions2.FetchProductPropertiesActionTypes.SUCCESS)), (0, _filter.filter)(function () {
    var pathName = (0, _selectors2.getPathNameFromRouting)(getState());
    return pathName.includes(_UrlPathParams.PRODUCTS);
  }), (0, _map.map)(function () {
    var query = (0, _selectors.getEditableTotalQuery)(getState());
    return (0, _actions.fetchEditableTotal)(query);
  }));
};

exports.getEditableTotalWhenFetching = getEditableTotalWhenFetching;
var createProduct = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: ProductsAPI.create,
  initiatingActionType: _actions.ProductActionTypes.CREATE_PRODUCT,
  requestActions: _actions.CreateProduct,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.ProductActionTypes.CREATE_PRODUCT)
}));
exports.createProduct = createProduct;
var createProductAndAdd = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: ProductsAPI.create,
  initiatingActionType: _actions.ProductActionTypes.CREATE_PRODUCT_AND_ADD,
  requestActions: _actions.CreateProductAndAddAnother,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.ProductActionTypes.CREATE_PRODUCT_AND_ADD)
}));
exports.createProductAndAdd = createProductAndAdd;

var editAfterCreating = function editAfterCreating($action) {
  return $action.ofType(_actions.CreateProductAndAddAnotherActionTypes.SUCCESS).pipe((0, _mapTo.mapTo)((0, _actions.editProduct)(0)));
};

exports.editAfterCreating = editAfterCreating;
var updateProduct = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: ProductsAPI.update,
  initiatingActionType: _actions.ProductActionTypes.UPDATE_PRODUCT,
  requestActions: _actions.UpdateProduct,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.ProductActionTypes.UPDATE_PRODUCT)
}));
exports.updateProduct = updateProduct;
var deleteProduct = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: ProductsAPI.remove,
  initiatingActionType: _actions.ProductActionTypes.DELETE_PRODUCT,
  requestActions: _actions.DeleteProduct,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.ProductActionTypes.DELETE_PRODUCT)
}));
exports.deleteProduct = deleteProduct;
var mutateProducts = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.mutateProducts,
  initiatingActionType: _actions.ProductActionTypes.MUTATE_PRODUCTS,
  requestActions: _actions.MutateProducts,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.ProductActionTypes.MUTATE_PRODUCTS)
}));
exports.mutateProducts = mutateProducts;

var _default = (0, _reduxObservable.combineEpics)(fetchProduct, fetchEditableTotal, getEditableTotalWhenFetching, createProduct, createProductAndAdd, editAfterCreating, updateProduct, deleteProduct, mutateProducts);

exports.default = _default;